<template>
  <div
    :key="this.$store.state.activeBusiness.id"
    class="wrapper"
    :class="{ 'nav-open': $sidebar.showSidebar }"
  >
    <side-bar
      :title.sync="this.$store.state.activeBusiness.name"
      @click="openChangeBusinessModal()"
    >
      <sidebar-link
        v-for="menuItem of menu"
        :to="menuItem.path"
        :key="menuItem.path"
        :exact="menuItem.path === '/'"
      >
        <md-icon>{{ menuItem.icon }}</md-icon>
        <p>{{ menuItem.label }}</p>
      </sidebar-link>
    </side-bar>

    <div class="main-panel">
      <top-navbar></top-navbar>

      <transition name="fade" mode="out-in">
        <router-view></router-view>
      </transition>

      <content-footer></content-footer>
    </div>

    <SwitchBusinessModal
      ref="switchBusinessModal"
      :businesses="businesses"
      @onBusinessChange="onBusinessChange"
      :businessLoading="businessLoading"
    />
  </div>
</template>
<script>
import { getRoutes } from "@/utils/Acl.util";
import { sidemenu } from "@/config/";
import TopNavbar from "./TopNavbar.vue";
import ContentFooter from "./ContentFooter.vue";
import SwitchBusinessModal from "./SwitchBusinessModal.vue";
import { formatAmount } from "../../utils/Formatter.util";

export default {
  components: {
    TopNavbar,
    ContentFooter,
    SwitchBusinessModal,
  },
  computed: {
    userData() {
      return this.$store.state.userData;
    },
    menu() {
      return this.getRoutes(sidemenu);
    },
  },
  created() {
    this.getActiveBusiness();
  },

  data() {
    return {
      businesses: [],
      businessLoading: false,
      activeBusiness: {},
      showDialog: false,
    };
  },
  methods: {
    getActiveBusiness() {
      this.$parent.getActiveBusiness();
    },
    getRoutes,
    onBusinessChange(selected) {
      this.$parent.updateActiveBusiness(selected);
      this.showDialog = false;
    },
    async openChangeBusinessModal() {
      this.businessLoading = true;
      this.$refs.switchBusinessModal.onOpen();
      this.$sidebar.showSidebar = false;
      this.businesses = await this.$parent.getBusinesses();
      this.businessLoading = false;
    },
    formatAmount,
  },
};
</script>
<style lang="scss" scoped>
.md-dialog /deep/.md-dialog-container {
  max-width: 640px;
}
.pointer {
  cursor: pointer;
}
.pointer:hover {
  background-color: #edf2f7;
  color: white;
}
</style>
